import { useEffect, useState } from 'react';
import {
  getProxyAssetUrl,
  resolveAssetUrl,
} from '../../utils/url';

export const useBundleProductImageSrc = (
  imageKey: string,
  assetUrl: string
) => {
  const [src, setSrc] = useState('');
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!imageKey) {
      setSrc('');
      setFailed(false);
      return;
    }

    setFailed(false);
    setSrc(resolveAssetUrl(imageKey, assetUrl));
  }, [imageKey, assetUrl]);

  const handleError = () => {
    if (!imageKey) return;

    const proxyUrl = getProxyAssetUrl(imageKey);
    if (src !== proxyUrl) {
      setSrc(proxyUrl);
      return;
    }

    setFailed(true);
  };

  return { src, failed, handleError };
};
